<template>
  <div>
    <div class="ts-flex">
      <select
        class="ts-border ts-border-r-0 ts-rounded-tl ts-rounded-bl ts-outline-none"
        v-model="grade"
        @change="onFetchSerial()"
      >
        <option value="A">A</option>
        <option value="B">B</option>
        <option value="C">C</option>
        <option value="D">D</option>
      </select>
      <div class="ts-relative ts-w-full">
        <input
          v-model.trim="search"
          ref="search"
          type="text"
          class="ts-w-full ts-border ts-border-l-0 ts-float-right ts-px-2 ts-py-1 ts-rounded ts-rounded-tl-none ts-rounded-bl-none ts-outline-none ts-pr-6"
          :placeholder="$t('wholesale.serialOnly')"
        />
        <span
          class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
          style="margin-top: 7px"
          ><i class="fa fa-search"></i
        ></span>
      </div>
    </div>
    <ts-loading-banner :loading="loading">
      <div
        class="ts-border ts-border-blue-600 ts-p-3 ts-rounded ts-mt-3 max-height ts-overflow-scroll"
      >
        <table class="ts-w-full">
          <tr
            class="ts-border-b ts-border-gray-200 ts-cursor-pointer hover:ts-bg-blue-300"
            v-for="(serial, index) in serialList"
            :key="index"
            @click.prevent="addSerialNum(serial)"
          >
            <td>{{ serial.serial_no + ' - ' + serial.product_grade }}</td>
          </tr>
        </table>
      </div>
      <small
        ><i>{{ $t('wholesale.clickToAddSerial') }}</i></small
      >
    </ts-loading-banner>
    <div
      class="ts-mt-3 ts-bg-gray-200 ts-rounded ts-p-3 ts-overflow-scroll"
      style="height: 55vh"
    >
      <div
        class="ts-flex ts-justify-between"
        v-for="(num, index) in model.serial_list"
        :key="index"
      >
        <p class="ts-mb-0 ts-font-extrabold ts-tracking-wider">
          {{ num.serial_no + ' - ' + num.product_grade }}
        </p>
        <a href="#">
          <i
            class="fas fa-times ts-text-red-700"
            @click.prevent="remove(index)"
          ></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'addProductSerialManual',
  props: ['value', 'product_detail'],
  data() {
    return {
      search: '',
      grade: 'A',
      model: {},
      loading: false,
      serials: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/operation', ['setting']),
    serialList() {
      let serial_list = []
      this.product_detail.forEach(el => {
        el.serial_list.map(e => serial_list.push(e.serial_no))
      })
      return this.serials.filter(s => !_.includes(serial_list, s.serial_no))
    }
  },
  methods: {
    ...mapActions('wholesale/operation', ['findProductSerial']),
    onFetchSerial() {
      this.serials = []
      this.loading = true
      this.findProductSerial({
        productId: this.model.product_id,
        attributes: {
          search: this.search,
          grade: this.grade
        }
      })
        .then(response => {
          this.serials = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addSerialNum(serial) {
      if (this.setting.is_accounting) {
        this.model.serial_list = []
      }
      this.model.serial_list.push(serial)
      this.model.quantity = this.model.serial_list.length
      this.$emit('calculate')
    },
    remove(index) {
      this.model.serial_list.splice(index, 1)
      this.model.quantity = this.model.serial_list.length
      this.$emit('calculate')
    }
  },
  watch: {
    search: debounce(function() {
      this.onFetchSerial()
    }, 500)
  }
}
</script>

<style scoped>
.max-height {
  height: 20vh;
  max-height: 22vh;
}
</style>
